<template>
  <transition name="fade">
    <div class="home flex">
      <side-menu />
      <div class="lg:pl-16 flex-grow w-full">
        <NavBar title="Dashboard" />
        <Loader v-if="loading" />
        <div
          v-else
          class="flex flex-col xl:flex-row md:items-start dashboard-container md:justify-between xl:px-8 2xl:px-12 py-8"
        >
          <div
            class="w-full xl:w-8/12 xl:mr-8 2xl:mr-12 flex flex-col chart-container xl:sticky xl:top-8 xl:self-start"
          >
            <Summary @on-active="onActive" />
            <LineChart />
          </div>
          <tips :which="active" />
        </div>
        <div
          class="footer w-full h-12 flex items-center justify-end md:px-4 xl:px-12 sticky bottom-0 bg-bs-bg dark:bg-bs-dark-bg"
        >
          <router-link to="/terms" class="mr-4 text-xs mt-2 dark:text-white border-r pr-4"
            >Terms &amp; Conditions</router-link
          >
          <a href="https://www.begambleaware.org/" target="_blank">
            <img
              :src="
                theme === 'dark'
                  ? '/img/gambleaware/begambleawareorg_white_png.png'
                  : '/img/gambleaware/begambleawareorg_black_png.png'
              "
              class="h-6"
              alt="Be Gamble Aware"
            />
          </a>
        </div>
      </div>
      <mob-menu class="lg:hidden" />
    </div>
  </transition>
</template>

<script>
// @ is an alias to /src
import firebase from "@/firebase";
import NavBar from "@/components/organisms/NavBar.vue";
import LineChart from "@/components/organisms/LineChart.vue";
import Summary from "@/components/molecules/Summary.vue";
import Loader from "@/components/atoms/Loader.vue";
import SideMenu from "@/components/organisms/SideMenu.vue";
import MobMenu from "@/components/organisms/MobMenu.vue";
import TipsByStatus from "@/components/organisms/TipsByStatus.vue";
import Tips from "@/components/molecules/Tips.vue";
import DeviceDetector from "device-detector-js";
const deviceDetector = new DeviceDetector();
import { mapActions, mapState } from "vuex";
// import Socket from '@/socket'

export default {
  name: "Home",
  components: {
    NavBar,
    LineChart,
    Summary,
    Loader,
    SideMenu,
    MobMenu,
    TipsByStatus,
    Tips
  },
  data: function () {
    return {
      loading: true,
      transitionName: "slither",
      timeout: undefined,
      active: undefined
    };
  },
  computed: {
    ...mapState(["theme"]),
  },
  watch: {
    $route: function (to, from) {
      if (from.path.indexOf("/tips") > -1) {
        this.transitionName = "drain";
      } else {
        this.transitionName = "slither";
      }
    },
  },
  created: async function () {
    this.loading = true;
    this.checkForRole()
    this.getSettings();
    await this.getData();
    this.loading = false;
  },
  mounted: function () {
    this.registerForPush();
  },
  unmounted: function () {
    clearTimeout(this.timeout);
  },
  methods: {
    ...mapActions({
      getSettings: "getSettings",
      getHistory: "getHistory",
      getSummary: "getSummary",
    }),
    getData: async function () {
      // Pull settings first so getHistory can use settings.setupDate to size
      // the window — otherwise the first chart paint after login only shows
      // the default 365-day fallback.
      await this.getSettings();
      await this.getHistory();
      await this.getSummary();
      this.timeout = setTimeout(() => {
        this.getData();
      }, 30000);
    },
    registerForPush: function () {
      if (firebase?.messaging?.isSupported()) {
        const messaging = firebase.messaging();

        messaging
          .requestPermission()
          .then(() => {
            messaging
              .getToken({
                vapidKey:
                  "BAJ3q-w1dLFN5hAej35eMSsagoDDXwz5A_tb28Deh2gdRu3w-dvWISJCGe310-6SBUXASUPnL6daXeI4UVdAMWA",
              })
              .then((token) => {
                this.pushToken = token
                this.saveNotificationToken(token);
              });
          })
          .catch((err) => {
            console.log("Unable to get permission to notify.", err);
          });

        messaging.onTokenRefresh(() => {
          messaging
            .getToken({
              vapidKey:
                "BAJ3q-w1dLFN5hAej35eMSsagoDDXwz5A_tb28Deh2gdRu3w-dvWISJCGe310-6SBUXASUPnL6daXeI4UVdAMWA",
            })
            .then((newToken) => {
              this.saveNotificationToken(newToken);
            })
            .catch(function (err) {
              console.log(err);
            });
        });

        messaging.onMessage((payload) => {
          // let message = payload?.data?.value
          let notificationType = payload?.data?.notificationType || "TIP";
          let audio;
          switch (notificationType.toUpperCase()) {
            case "TIP":
              audio = new Audio("/s/tip.ogg");
              break;
            case "SUCCESS":
              audio = new Audio("/s/success.ogg");
              break;
            case "FAIL":
              audio = new Audio("/s/fail.ogg");
              break;
            default:
              audio = new Audio("/s/tip.ogg");
              break;
          }
          audio.play();
          clearTimeout(this.timeout);
          this.getData();
        });
      }
    },
    saveNotificationToken: function (pushNotificationToken) {
      
      const { os, client, device } = deviceDetector.parse(navigator.userAgent);

      this.$store.dispatch("updateDeviceToken", {
        deviceKey: `${device.brand} ${device.model} ${os.name} ${os.version} ${client.name} ${client.version}`.trim(),
        pushNotificationToken,
      });
    },
    onLogout: function () {
      firebase.auth().signOut();
      this.$router.replace({ name: "Login" });
    },
    onActive: function (active) {
      this.active = active;
    },
    checkForRole: async function () {
      let token = this.$store.state.sessionToken;
      let t = token.split(".")[1];
      let { roles } = JSON.parse(atob(t));
      
      if (!roles || (roles && roles.indexOf("registered") === -1)) {
         await this.$store.dispatch("updateDevice", {
          uuid: localStorage.getItem("_devK")
        });
        let user = await firebase.getCurrentUser()
        let newToken = await user.getIdToken(true);
        this.$store.commit("setAccessToken", newToken);
        this.loading = true;
        this.getSettings();
        await this.getData();
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
@screen xl {
  .dashboard-container {
    margin: 0 auto;
  }
}
@screen 2xl {
  .chart-container {
    min-height: calc(100vh - 140px - 4rem);
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
